import { checkDate } from "common/helpers/Date";
import { Nullable } from "common/types";
import { Record } from "immutable";
import { DateStringNumber } from "common/records";

export const levelFromJSON = (json: Partial<ILevelData>): LevelRecord => {
  const recordData: ILevelRecord = { ...(json as any) };
  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }
  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  if (json.org_level_link) {
    recordData.org_level_link = orgLevelLinkFromJSON(json.org_level_link);
  }

  return new LevelRecord(recordData);
};

export const orgLevelLinkFromJSON = (json: Partial<IOrgLevelLinkData>): OrgLevelLinkRecord => {
  const recordData = { ...(json as any) };
  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }
  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }
  return new OrgLevelLinkRecord(recordData);
};

export interface IOrgLevelLinkData {
  id: string;
  org_uuid: string;
  level_id: string;
  sort_order: number;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface ILevelData {
  id: string | number;
  name: string;
  org_id: Nullable<number>;
  org_level_link: Nullable<IOrgLevelLinkData>;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;

  loading?: boolean;
}

export interface IOrgLevelLinkRecord {
  id: string;
  org_uuid: string;
  level_id: string;
  sort_order: number;

  created_at: Date;
  updated_at: Date;
}

export interface ILevelRecord {
  id: string | number;
  name: string;
  org_id: Nullable<number>;
  org_level_link: Nullable<OrgLevelLinkRecord>;

  created_at: Date;
  updated_at: Date;

  loading: boolean;
}

export const defaultLevelProps = {
  id: "",
  name: "",
  org_id: null,
  org_level_link: null,
  created_at: new Date(),
  updated_at: new Date(),
  loading: false,
};

export const defaultOrgLevelLinkProps = {
  id: "",
  org_uuid: "",
  level_id: "",
  sort_order: 0,
  created_at: new Date(),
  updated_at: new Date(),
};

export class LevelRecord extends Record<ILevelRecord>(defaultLevelProps) implements ILevelRecord {}
export class OrgLevelLinkRecord
  extends Record<IOrgLevelLinkRecord>(defaultOrgLevelLinkProps)
  implements IOrgLevelLinkRecord {}
